export const parseHash = (hash: string): {[key: string]: string} => {
	const hashComps = hash.replace("#", "").split("=");

	const obj: { [key: string]: string } = {};

	for (let i = 0; i < hashComps.length - 1; i += 2) {
		obj[hashComps[i]] = hashComps[i + 1];
	}

	return obj;
};

/**
 * Converts a given object to json and calculates the digest of the converted string
 * 
 * @param object object to be hashed
 * @returns hash digest of the provided string
 */
export async function hashObject(object: unknown): Promise<string> {
  const json = JSON.stringify(object);

  // encode as (utf-8) Uint8Array
  const msgUint8 = new TextEncoder().encode(json);
  // hash the message
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
  // convert buffer to byte array
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  // convert bytes to hex string
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}